import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Input from "../../templates/Input";
import { useDispatch, useSelector } from "react-redux";
import { signupUser, clearError } from "../../store/authSlice";
import { subscribeUser } from "../../store/subscribeSlice";
import { FcGoogle } from "react-icons/fc";
import { loginWithGoogle } from "../../api/authAPI";

function Signup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.auth.loading);
  const errorFromStore = useSelector((state) => state.auth.error);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({});

  const signupFields = [
    {
      id: "name",
      label: "Name",
      type: "text",
      placeholder: "Enter your name",
      required: true,
    },
    {
      id: "email",
      label: "Email",
      type: "email",
      placeholder: "Enter your email",
      required: true,
    },
    {
      id: "password",
      label: "Password",
      type: "password",
      placeholder: "Enter your password",
      required: true,
    },
    {
      id: "phone",
      label: "Contact",
      type: "tel",
      placeholder: "Enter contact number",
      required: true,
    },
  ];

  useEffect(() => {
    return () => dispatch(clearError());
  }, [dispatch]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    setError("");
  };

  const handleEmailSignup = async (e) => {
    e.preventDefault();
    const payload = { ...formData, role: "User" };

    const result = await dispatch(signupUser(payload));
    if (signupUser.fulfilled.match(result)) {
      await dispatch(subscribeUser({ Email: formData.email }));
      navigate("/"); // Email/password signup redirect
    } else {
      setError(result.payload);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleGoogleSignup = async () => {
    // Redirect to Google OAuth
    await loginWithGoogle();
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-indigo-100 to-purple-100 px-4 sm:px-6 lg:px-8 mt-20">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 border-t-4 border-purple-500 mx-auto my-8">
        <h2 className="text-3xl font-extrabold text-center text-purple-700 mb-6">
          Sign Up
        </h2>

        {/* Google OAuth */}
        <button
          type="button"
          onClick={handleGoogleSignup}
          className="w-full flex items-center justify-center py-3 border border-gray-300 rounded-lg shadow hover:bg-gray-100 transition duration-300 mb-6"
        >
          <FcGoogle className="w-5 h-5 mr-3" />
          <span className="text-gray-700 font-medium">Sign up with Google</span>
        </button>

        {/* Error display */}
        {(error || errorFromStore) && (
          <div className="bg-red-100 text-red-700 p-3 mb-4 rounded-lg shadow-sm text-center">
            {error || errorFromStore}
          </div>
        )}

        {/* Email/password signup */}
        <form onSubmit={handleEmailSignup} className="space-y-6">
          <Input
            fields={signupFields}
            onChange={handleChange}
            formData={formData}
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-purple-600 text-white font-semibold rounded-lg shadow hover:bg-purple-700 transition duration-300"
          >
            {loading ? "Creating Account..." : "Sign Up"}
          </button>
        </form>

        <p className="text-center mt-6 text-gray-600">
          Already have an account?{" "}
          <Link
            to="/login"
            onClick={() => dispatch(clearError())}
            className="text-purple-600 font-medium underline hover:text-purple-800"
          >
            Login
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Signup;
